import { css } from 'styled-components'

export default css`
  &.G2ReviewModal {
    .BaseModal-Content.popup {
      width: 800px;
      max-width: 95vw;
      overflow: visible;
    }

    .G2ReviewModal-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
    }

    .G2ReviewModal-error {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
      color: var(--color-font-primary);
    }

    .G2ReviewModal-iframe {
      width: 100%;
      height: 700px;
      border: none;
    }
  }
`
